import styled from 'styled-components';

// ToDo: Need to change following dimsum class applied styling, need some alternative to change dimsum component style instead of dimsum class
export default styled.div`
  .em-ds-labelValue__wrapper {
    margin-left: 0px;
  }
`;
